if (!customElements.get("deployer-upsell")) {
  customElements.define(
    "deployer-upsell",
    class DeployerUpsell extends HTMLElement {
      constructor() {
        super();
        this.selects = this.querySelectorAll(".deployer-select");
        this.variantsData = {};

        this.form = this.querySelector(".deployer-upsell__form form");
        if (!this.form) return;
        this.formInputs = this.form.querySelectorAll("input");
        this.submitButton = this.form.querySelector('[name="add"]');
        this.discountType = this.dataset.discountType;
        this.dynamicSaving = this.dataset.dynamicSaving;

        this.init();
      }

      init() {
        this.initSelects();
        this.initForm();
        this.updatePrice();
      }

      initSelects() {
        this.selects.forEach((select) => {
          select.addEventListener("change", () => {
            this.updateVariant(select);
            this.updatePrice();
          });
        });
      }

      initForm() {
        this.form.addEventListener("submit", (e) => {
          e.preventDefault();
          this.addToCart();
        });
      }

      updateVariant(select) {
        const index = select.dataset.index;
        const variantId = select.value;
        const handle = select.dataset.handle;

        this.variantsData[handle] = {
          id: variantId,
          index: index,
        };

        this.updateFormInputs();
      }

      updateFormInputs() {
        this.formInputs.forEach((input) => {
          const handle = input.dataset.handle;
          if (this.variantsData[handle]) {
            input.value = this.variantsData[handle].id;
          }
        });
      }

      updatePrice() {
        if (!this.dynamicSaving) return;

        const legend = this.querySelector(".deployer-upsell__legend");
        if (!legend) return;

        const price = this.querySelector(".deployer-upsell__upsell-price span");
        const comparePrice = this.querySelector(".deployer-upsell__upsell-price s");

        if (!price || !comparePrice) return;

        const priceValue = parseFloat(price.textContent.replace(/[^0-9.,]/g, "").replace(",", "."));
        const comparePriceValue = parseFloat(comparePrice.textContent.replace(/[^0-9.,]/g, "").replace(",", "."));

        const saving = comparePriceValue - priceValue;
        let savingText = "";

        if (this.discountType === "percentage") {
          const percentage = Math.round((saving / comparePriceValue) * 100);
          savingText = `${percentage}%`;
        } else {
          savingText = `${saving.toFixed(2)}€`;
        }

        legend.innerHTML = legend.innerHTML.replace(/#/, savingText);
      }

      async addToCart() {
        this.submitButton.disabled = true;
        this.submitButton.classList.add("loading");

        try {
          const formData = new FormData(this.form);
          const response = await fetch("/cart/add.js", {
            method: "POST",
            body: formData,
          });

          if (!response.ok) throw new Error("Network response was not ok");

          const data = await response.json();
          window.location.href = "/cart";
        } catch (error) {
          console.error("Error:", error);
        } finally {
          this.submitButton.disabled = false;
          this.submitButton.classList.remove("loading");
        }
      }
    },
  );
}
